type Position = google.maps.LatLng | google.maps.LatLngLiteral | google.maps.LatLngAltitudeLiteral;

export type MarkerOverlayOptions = {
	map: google.maps.Map;
	position: Position;
	content: HTMLDivElement;
};

export type MarkerOverlay = {
	setPosition(position: Position): void;
} & google.maps.OverlayView;

export const useMarkerOverlay = (): {
	new (options: MarkerOverlayOptions): MarkerOverlay;
} => {
	return class extends google.maps.OverlayView {
		public map: google.maps.Map;
		public position: Position;
		public content: HTMLDivElement;
		public projectDiv?: HTMLDivElement;

		constructor(options: MarkerOverlayOptions) {
			super();
			this.map = options.map;
			this.position = options.position;
			this.content = options.content;

			this.setMap(this.map);
		}

		public onAdd() {
			this.content.classList.add("popup-bubble");

			// This zero-height div is positioned at the bottom of the bubble.
			const bubbleAnchor = document.createElement("div");
			bubbleAnchor.classList.add("popup-bubble-anchor");
			bubbleAnchor.appendChild(this.content);

			// This zero-height div is positioned at the bottom of the tip.
			this.projectDiv = document.createElement("div");
			this.projectDiv.classList.add("popup-project");
			this.projectDiv.appendChild(bubbleAnchor);

			// Optionally stop clicks, etc., from bubbling up to the map.
			google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.projectDiv);

			this.getPanes()?.floatPane.appendChild(this.projectDiv);
		}

		public onRemove() {
			if (this.projectDiv && this.projectDiv.parentElement) {
				this.projectDiv.parentElement.removeChild(this.projectDiv);
			}
		}

		public draw() {
			if (this.projectDiv && this.getProjection()) {
				const divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
				if (!divPosition) return;

				this.projectDiv.style.left = `${divPosition.x + 40}px`;
				this.projectDiv.style.top = `${
					divPosition.y - Math.floor(this.content.clientHeight / 2) - 18
				}px`;
			}
		}

		public setPosition(position: google.maps.LatLng) {
			this.position = position;
			this.draw();
		}
	};
};
